module.exports = __webpack_public_path__ + "static/monei_pay_starbucks_1_en-52e27a8b5b19940e69a4a0313f687edc.png";